module.exports = __webpack_public_path__ + "static/media/alc-book.ea22ce11.svg";